const ZoomAction = ({ value, onUpdate }) => (
  <input
    className="w-full"
    type="range"
    min="0"
    max="200.00"
    step="1"
    value={`${value}`}
    onChange={(e) => onUpdate(e.target.value)}
  />
);

export default ZoomAction;
